import React from 'react';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../../common/mixins';

const rules = ({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  opacity: theme.opacity.enabled,
  color: '#fff',
  height: theme.iconHeight.large,
  transition: theme.transition.default,
  willChange: 'opacity',
  ':hover': {
    opacity: theme.opacity.hovered,
  },
  extend: [
    largeScreen({
      height: theme.iconHeight.medium,
    }),
    smallScreen({
      height: theme.iconHeight.small,
    }),
  ],
});

const VolumeButton = (props) => {
  const { css } = useFela();

  return (
    <svg
      className={css(rules)}
      {...props}
      data-cy="hp-volume-button"
    />
  );
};

export default React.memo(VolumeButton);
